import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GetCookie } from "./common";
import { GetuserData } from "../Axios/user.axios";
import { LogOut } from "../redux/constants";

export default function CommonFunction () {

    // const dispatch = useDispatch();
    const Wallet_Details = useSelector((state) => state.wallet_detail)
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const UserCheck = async () => {
        let returndata = { status: false, cookie: false, login: false, error: false, errormsg: '' };
        try{
            let cookie = GetCookie();
            if(cookie){
                returndata.cookie = true
                let resp = await GetuserData({ data: cookie });
                if(resp?.data){
                    returndata.login = true;
                    returndata.status = true;
                }
                else{
                    returndata.login = false
                }
            }
            else{
                returndata.cookie = false
            }
            return returndata
        }
        catch(err){
            console.log('UserCheck_error',err);
            returndata.error = true;
            returndata.errormsg = String(err);
            return returndata
        }
    }

    const clearRedux = () => {
        dispatch({
            type: LogOut,
        })
    }

    return(
        {
            UserCheck,
            clearRedux,
        }
    )
}